import * as React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import caso01 from "@/assets/casos-antes-depois/caso-01.webp";
import caso02 from "@/assets/casos-antes-depois/caso-02.webp";
import caso03 from "@/assets/casos-antes-depois/caso-03.webp";
import caso04 from "@/assets/casos-antes-depois/caso-04.webp";
import caso05 from "@/assets/casos-antes-depois/caso-05.webp";
import caso06 from "@/assets/casos-antes-depois/caso-06.webp";
import caso07 from "@/assets/casos-antes-depois/caso-07.webp";
import caso08 from "@/assets/casos-antes-depois/caso-08.webp";
import caso09 from "@/assets/casos-antes-depois/caso-09.webp";
import caso10 from "@/assets/casos-antes-depois/caso-10.webp";
import caso11 from "@/assets/casos-antes-depois/caso-11.webp";
import caso12 from "@/assets/casos-antes-depois/caso-12.webp";
import caso13 from "@/assets/casos-antes-depois/caso-13.webp";
import caso14 from "@/assets/casos-antes-depois/caso-14.webp";
import caso15 from "@/assets/casos-antes-depois/caso-15.webp";
import caso16 from "@/assets/casos-antes-depois/caso-16.webp";
import caso17 from "@/assets/casos-antes-depois/caso-17.webp";
import caso18 from "@/assets/casos-antes-depois/caso-18.webp";

const clinicImages = [
  { src: caso01, alt: "Caso antes e depois - tratamento dentário", title: "Lentes de Contato" },
  { src: caso02, alt: "Caso antes e depois - sorriso", title: "Harmonização do Sorriso" },
  { src: caso03, alt: "Caso antes e depois - preenchimento labial", title: "Preenchimento Labial" },
  { src: caso04, alt: "Caso antes e depois - preenchimento labial", title: "Preenchimento Labial" },
  { src: caso05, alt: "Caso antes e depois - preenchimento labial", title: "Preenchimento Labial" },
  { src: caso06, alt: "Caso antes e depois - preenchimento labial", title: "Preenchimento Labial" },
  { src: caso07, alt: "Caso antes e depois - preenchimento labial", title: "Preenchimento Labial" },
  { src: caso08, alt: "Caso antes e depois - sorriso masculino", title: "Transformação do Sorriso" },
  { src: caso09, alt: "Caso antes e depois - correção gengival", title: "Correção Gengival" },
  { src: caso10, alt: "Caso antes e depois - tratamento dentário", title: "Lentes de Contato" },
  { src: caso11, alt: "Caso antes e depois - lentes de contato dental", title: "Lentes de Contato" },
  { src: caso12, alt: "Caso antes e depois - clareamento dental", title: "Clareamento Dental" },
  { src: caso13, alt: "Caso antes e depois - restauração dental", title: "Restauração Estética" },
  { src: caso14, alt: "Caso antes e depois - harmonização do sorriso", title: "Harmonização do Sorriso" },
  { src: caso15, alt: "Caso antes e depois - tratamento dental completo", title: "Tratamento Completo" },
  { src: caso16, alt: "Caso antes e depois - lentes de contato dental", title: "Lentes de Contato" },
  { src: caso17, alt: "Caso antes e depois - restauração dental", title: "Restauração Estética" },
  { src: caso18, alt: "Caso antes e depois - prótese dental", title: "Prótese Dental" },
];

const extendedClinicImages = [...clinicImages, ...clinicImages];

const ClinicCarousel = () => {
  const swiperRef = React.useRef<any>(null);
  const [currentSlide, setCurrentSlide] = React.useState(1);
  const [totalSlides] = React.useState(clinicImages.length);
  
  React.useEffect(() => {
    swiperRef.current?.autoplay?.start?.();
  }, []);
  
  return (
    <section className="py-4 sm:py-5 lg:py-6" style={{ backgroundColor: '#F6F5F5' }}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16 animate-fade-in-up">
          <p className="text-accent font-inter text-sm uppercase tracking-wider mb-3 inline-block px-4 py-2 rounded-full border border-accent/30 bg-accent/5">
            Resultados Reais
          </p>
          <h2 className="font-kiona text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mt-4 mb-4 uppercase">
            Antes & Depois
          </h2>
          <p className="text-muted-foreground font-inter text-lg max-w-2xl mx-auto">
            Confira alguns dos resultados transformadores realizados pela Dra. Natália Piller
          </p>
        </div>

        <div className="relative max-w-7xl mx-auto pb-6 sm:pb-8 lg:pb-12">
          <Swiper
            onSwiper={(swiper) => { swiperRef.current = swiper; }}
            onSlideChange={(swiper) => {
              const realIndex = swiper.realIndex % clinicImages.length;
              setCurrentSlide(realIndex + 1);
            }}
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={'auto'}
            spaceBetween={24}
            watchSlidesProgress={true}
            loop={true}
            loopAdditionalSlides={6}
            
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 120,
              modifier: 1,
              slideShadows: true,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            navigation={false}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            modules={[EffectCoverflow, Pagination, Navigation, Autoplay]}
            className="clinic-swiper"
            breakpoints={{
              320: {
                coverflowEffect: {
                  rotate: 30,
                  depth: 80,
                }
              },
              768: {
                coverflowEffect: {
                  rotate: 50,
                  depth: 120,
                }
              }
            }}
          >
            {extendedClinicImages.map((image, index) => (
              <SwiperSlide key={index} className="!w-[320px] md:!w-[450px] lg:!w-[550px]">
                <Card className="group bg-card/50 backdrop-blur-sm border-border/50 hover:border-accent/50 transition-all duration-500 hover:shadow-silver-lg overflow-hidden">
                  <CardContent className="p-0 relative aspect-square">
                    <div className="absolute inset-0 bg-gradient-silver-subtle opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10" />
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-110"
                      loading="lazy"
                    />
                    <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent z-20">
                      <h3 className="font-kiona text-xl font-semibold text-white uppercase">
                        {image.title}
                      </h3>
                    </div>
                  </CardContent>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
          
          <div className="text-center mt-4 sm:mt-6 lg:mt-8">
            <p className="text-foreground font-inter text-lg font-semibold">
              {currentSlide} / {totalSlides}
            </p>
          </div>
        </div>
      </div>

      <style>{`
        .clinic-swiper {
          padding-top: 50px;
          padding-bottom: 50px;
          overflow: visible;
        }
        
        @media (max-width: 640px) {
          .clinic-swiper {
            padding-top: 25px;
            padding-bottom: 25px;
          }
        }
        
        .clinic-swiper .swiper-slide {
          background-position: center;
          background-size: cover;
        }
        
        .clinic-swiper .swiper-pagination-bullet {
          background: hsl(var(--accent));
          opacity: 0.5;
        }
        
        .clinic-swiper .swiper-pagination-bullet-active {
          opacity: 1;
        }
        
        .clinic-swiper .swiper-button-next,
        .clinic-swiper .swiper-button-prev {
          color: white;
          background: hsl(var(--primary));
          width: 48px;
          height: 48px;
          border-radius: 12px;
          border: none;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: 0 4px 12px hsl(var(--primary) / 0.3);
          top: 50%;
        }
        
        .clinic-swiper .swiper-button-next:after,
        .clinic-swiper .swiper-button-prev:after {
          font-size: 18px;
          font-weight: bold;
        }
        
        .clinic-swiper .swiper-button-next:hover,
        .clinic-swiper .swiper-button-prev:hover {
          background: hsl(var(--primary) / 0.9);
          transform: scale(1.08);
          box-shadow: 0 6px 20px hsl(var(--primary) / 0.4);
        }
        
        .clinic-swiper .swiper-button-next:active,
        .clinic-swiper .swiper-button-prev:active {
          transform: scale(0.98);
        }
        
        .clinic-swiper .swiper-button-disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }
        
        @media (max-width: 768px) {
          .clinic-swiper .swiper-button-next,
          .clinic-swiper .swiper-button-prev {
            width: 40px;
            height: 40px;
          }
          
          .clinic-swiper .swiper-button-next:after,
          .clinic-swiper .swiper-button-prev:after {
            font-size: 14px;
          }
        }
      `}</style>
    </section>
  );
};

export default ClinicCarousel;
